module.exports = __webpack_public_path__ + "img/inside-front.48701482.png";